import { ProductInterface } from '@bytel/product-wall/types';

import { getSessionVariable, setSessionVariable } from '@services/storage';

export function storeComparator(comparedProducts: ProductInterface[]) {
    setSessionVariable(
        'catalog_comparator',
        JSON.stringify({
            data: comparedProducts,
        }),
    );
}

export function getStoredComparator(): ProductInterface[] {
    const storedComparator = getSessionVariable('catalog_comparator');
    const response = storedComparator ? JSON.parse(storedComparator) : { data: [] };
    return response?.data ?? [];
}
